module.exports = __webpack_public_path__ + "img/question.753387b8.svg";